import styled from 'styled-components';

export const ListTypeButton = styled.div`
  flex-direction: row;
  align-items: center;
  background-color: ${({ selected }) =>
    selected
      ? 'var(--cc_color_button_background_tint)'
      : 'var(--cc_color_background_1)'};
  border: ${({ selected }) =>
    selected
      ? 'var(--cc_color_border_input_active)'
      : 'var(--cc_color_border_input_inactive)'};
  border-width: var(--cc_size_border_width_s);
  border-radius: var(--cc_size_border_radius_m);
  margin: var(--cc_size_spacing_xs);
`;

export const LargeParagraph = styled.p`
  font-weight: 400;
  font-size: var(--cc_size_text_l);
  line-height: 1.5;
  color: var(--cc_color_text_subtle);
`;

export const LightTextSmall = styled.p`
  font-size: var(--cc_size_text_xs);
  color: var(--cc_color_text_subtle);
`;

export const Text = styled.p`
  font-size: var(--cc_size_text_m);
  margin: 0;
  color: var(--cc_color_text_subtle);
`;

export const SmallText = styled.p`
  font-size: var(--cc_size_text_xs);
  margin: 0;
  color: var(--cc_color_text_subtle);
`;
